import { EUserJourneyType } from '@pkg/lib-data'

export const SHOWS_CATEGORY_ID = 'shows'

export const SHOWS_USER_JOURNEY_TYPE = EUserJourneyType.SHOWS
